<template>
  <section class="BaseLoginForBusinessUser">
    <h1>Это страница для входа в аккаунт <strong>бизнес-юзера</strong></h1>
  </section>
</template>
<script>
export default {
  name: "BaseLoginForBusinessUser",
};
</script>
<style></style>
